import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "../src/assets/css/style.css";
import "../src/assets/css/default.css";
import "../src/assets/css/custom.css";
// import "../src/assets/js/custom"
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
// React Redux In Set Provider
import { Provider } from "react-redux";
import store from "./Component/store/Provider";

// Connect Axios
import { baseURL, secretKey } from "./util/config";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import Loader from "./util/Loader";
import {
  CLOSE_LOADER,
  LOADER_OPEN,
} from "./Component/store/dialogue/dialogue.type";

// Default Base URL Join In Axios
axios.defaults.baseURL = baseURL;

// Default Key Join In Axios
axios.defaults.headers.common["key"] = secretKey;

axios.interceptors.request.use(
  (req) => {
    store.dispatch({ type: LOADER_OPEN });
    // 🔍 DEBUG: Логируем все запросы
    console.log("🚀 REQUEST →", {
      method: req.method?.toUpperCase(),
      url: req.url,
      baseURL: req.baseURL,
      fullURL: `${req.baseURL}${req.url}`,
      headers: req.headers,
      data: req.data,
    });
    return req;
  },
  (error) => {
    console.error("❌ REQUEST ERROR:", error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (res) => {
    store.dispatch({ type: CLOSE_LOADER });
    // 🔍 DEBUG: Логируем все ответы
    console.log("✅ RESPONSE ←", {
      status: res.status,
      statusText: res.statusText,
      url: res.config?.url,
      data: res.data,
    });
    return res;
  },
  (err) => {
    store.dispatch({ type: CLOSE_LOADER });
    // 🔍 DEBUG: Логируем ошибки
    console.error("❌ RESPONSE ERROR ←", {
      message: err.message,
      status: err.response?.status,
      statusText: err.response?.statusText,
      url: err.config?.url,
      data: err.response?.data,
    });
    if (err.message === "Network Error") {
      console.error("🌐 Network Error - проверьте подключение к серверу");
    }
    return Promise.reject(err);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
        <ToastContainer />
        <Loader />
      </Provider>
    </BrowserRouter>
  // </React.StrictMode>
);

reportWebVitals();
